import { Input, InputProps } from '@/components/ui/Input/Input';
import * as React from 'react';
import { cn } from '@/lib/utils.ts';
import { Label } from './Label';

export interface InputFormProps extends InputProps {
  value?: string;
  label?: string;
  placeholder?: string;
  handleChange?: (value: string) => void;
  width?: string;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  error?: string | undefined;
  labelClassName?: string;
}

const InputForm = React.forwardRef<HTMLInputElement, InputFormProps>(
  (
    {
      value,
      label,
      required,
      readOnly,
      disabled,
      width = '100%',
      error,
      placeholder,
      handleChange,
      className,
      type,
      labelClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn('flex flex-col w-full items-start', className)}>
        {label &&
          <Label
            className={
              labelClassName ??
              cn(
                disabled ? 'opacity-50' : '',
                readOnly ? 'text-bodySmall py-[12px]' : '',
                error ? 'text-[#B00120]' : '',
              )}
          >
            {label}{required ? '*' : ''}
          </Label>
        }
        {readOnly ?
          <p className='w-[360px] h-[52px] text-headingSmall'>{value}</p> :
          <Input
            placeholder={placeholder}
            onChange={e => handleChange?.(e.target.value)}
            width={width}
            value={value ?? ''}
            type={type}
            className={cn(
              'flex w-full h-[52px] rounded-sm bg-[#F7F7F7] px-5 py-1 text-bodyLarge transition-colors file:border-0 file:bg-transparent file:text-bodyMedium file:text-foreground placeholder:text-[#7C7C7C] placeholder:text-textSmall disabled:cursor-not-allowed disabled:opacity-50',
              disabled ? 'cursor-not-allowed opacity-50' : '',
              error
                ? 'border border-[#B00120] bg-[#FDF7F8] focus-visible:ring-0 focus-visible:outline-none'
                : 'border-[rgba(0,0,0,0.05)] border-[0.5px] focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none'
            )}
            ref={ref}
            {...props}
          />
        }
        {error && <p className="text-[#B00120] text-bodySmall pt-[6px]">{error}</p>}
      </div>
    );
  }
);
InputForm.displayName = 'InputForm';

export { InputForm };
